export default "__VITE_ASSET__d82072fb__"